import React from 'react'
import classNames from 'classnames'
import { MonetaryAmountFragment } from '#src/generated/graphql'
import styles from './styles.css'

interface Props {
  className?: string
  amount: MonetaryAmountFragment
  type: 'product' | 'payment' | 'homepage' | 'landing' | 'search' | 'category' | 'cart' | 'banner'
}

export default class AffirmMonthlyPayment extends React.PureComponent<Props> {
  public componentDidMount() {
    window.affirm.ui.ready(() => window.affirm.ui.refresh())
  }

  public componentDidUpdate() {
    window.affirm.ui.ready(() => window.affirm.ui.refresh())
  }

  public render() {
    const { amount, type, className } = this.props

    /**
     * The `affirm-as-low-as` class is used for injecting on an element
     */
    return (
      <div
        className={classNames('affirm-as-low-as', styles.affirm, className)}
        data-page-type={type}
        data-amount={Math.round(parseFloat(amount.amount) * 100)}
      />
    )
  }
}
